module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/checkCircularBlack.c1b120f4.svg";